import { Component } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  loggedIn?: boolean = false;
  showHeader: boolean = true;

  private hiddenRoutes = ['/klyant/'];

  constructor(
    public authService: AuthService,
    private router: Router
  ) 
  {
    this.authService.isLogin.subscribe(status => {
      this.loggedIn = status;
    });

    // Hides the header on that klyant popup used for authorising
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.showHeader = !this.hiddenRoutes.some(route => event.urlAfterRedirects.startsWith(route));
    });

    
  }
}
